module.exports = __webpack_public_path__ + "img/report_footer_icon.68bc77b9.png";